import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=24b3f54c&"
import script from "./Articles.vue?vue&type=script&lang=ts&"
export * from "./Articles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports